import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class MappingService {
    async updateValue(dataSource: any, mapping: any): Promise<string> {
        const caseInstance = dataSource?.caseInstance;
        const caseObject = caseInstance?.caseData?.data;
        const taskInstance = dataSource?.taskInstance || dataSource?.taskInstances;
        const signalInstance = dataSource?.signalInstance;

        const mappingPath = mapping.mapping;
        const mappingType = mapping.mappingType;
        let value: any = null;

        const _get = window.ap.jval.get;

        switch (mappingType) {
            case 'co':
                value = _get(caseObject, mappingPath);
                break;
            case 'case_instance':
                value = _get(caseInstance, mappingPath);
                break;
            case 'task_instance':
                value = _get(taskInstance, mappingPath);
                break;
            case 'signal_instance':
                value = _get(signalInstance, mappingPath);
                break;
            default:
                value = Promise.resolve('');
                break;
        }

        try {
            const resolvedValue = await value;
            return Array.isArray(resolvedValue)
                ? resolvedValue.map((r) => this.getValue(mapping, r)).join(', ')
                : this.getValue(mapping, resolvedValue);
        } catch (error) {
            console.error(error);
            return '';
        }
    }

    private getValue(mapping: any, value: any) {
        switch (mapping.type) {
            case 'date':
                if (value && window.ap.moment(value).isValid()) return window.ap.moment(value).format('DD/MM/YYYY');
                return value;
            case 'date-time':
                const { dateTimeFormat } = mapping;
                if (value && window.ap.moment(value).isValid()) return window.ap.moment(value).format(dateTimeFormat);
                return value;
            case 'string':
                const { dateTimeFormat: dateFormat, format } = mapping;
                if (value && format === 'date' && window.ap.moment(value).isValid()) {
                    return window.ap.moment(value).format(dateFormat);
                }
                return value;

            default:
                return value;
        }
    }
}
